import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import axios from 'axios';

import config from "../config.json";
import malePlaceholder from "../media/ManagementTeam/male.png";

type Employee = {
  id?: string | number;
  first_name?: string;
  last_name?: string;
  name?: string;
  full_name?: string;
  fullname?: string;
  email?: string;
  title?: string;
  designation?: string;
  position?: string;
  usertype?: string;
  photo_url?: string;
  photo?: string;
  image?: string;
  src?: string;
  attachment?: string;
  bio?: string;
  description?: string;
  address?: string;
};

type ManagementTeamProps = {
  teamType: "bod" | "management";
  pageTitle: string;
};

const ManagementTeam: React.FC<ManagementTeamProps> = ({ teamType, pageTitle }) => {
  const [employees, setEmployees] = useState<Employee[]>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchEmployees();
  }, [teamType]);

  const fetchEmployees = async () => {
    try {
      const response = await axios.get(config.prodURL + "getemployees");
      const payload = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
      const allEmployees = Array.isArray(payload) ? payload : payload?.results || payload?.data || [];

      const filteredEmployees = allEmployees.filter((employee: Employee) => {
        const usertype = employee.usertype?.trim().toLowerCase();
        return teamType === "bod" ? usertype === "bod" : usertype !== "bod";
      });

      setEmployees(filteredEmployees);
    } catch (error) {
      console.error("Error fetching employees:", error);
      setEmployees([]);
    }
  };

  const getEmployeeName = (employee: Employee) =>
    `${employee.first_name || ""} ${employee.last_name || ""}`.trim() ||
    employee.name ||
    employee.fullname ||
    employee.full_name ||
    "Team Member";

  const getEmployeeTitle = (employee: Employee) =>
    employee.title || employee.designation || employee.position || "Leadership Team";

  const getEmployeeImage = (employee: Employee) =>
    employee.photo_url || employee.photo || employee.image || employee.src || employee.attachment || malePlaceholder;

  return (
    <div className="management-team-container">
      <div className="content leadership-content">
        <h1>{pageTitle}</h1>
        <Row gutter={[20, 20]} justify="center" className="leadership-grid">
          {employees.map((member, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={member.id || index} className="avatar-column">
              <Link
                to="/profile"
                state={{
                  src: getEmployeeImage(member),
                  name: getEmployeeName(member),
                  title: getEmployeeTitle(member),
                  email: member.email,
                  address: member.address,
                  bio: member.bio || member.description,
                }}
                className="leadership-card-link"
              >
                <div className="avatar-item leadership-card">
                  <img
                    src={getEmployeeImage(member)}
                    alt={getEmployeeName(member)}
                    width={140}
                    className="leadership-avatar"
                  />
                  <div className="leadership-name"><strong>{getEmployeeName(member)}</strong></div>
                  <div className="leadership-title">{getEmployeeTitle(member)}</div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ManagementTeam;
